import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=32ecf835&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=ts"
export * from "./Page404.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ecf835",
  null
  
)

export default component.exports